import { render, staticRenderFns } from "./dynamic-textarea.vue?vue&type=template&id=5668ccfd&scoped=true&"
import script from "./dynamic-textarea.vue?vue&type=script&lang=js&"
export * from "./dynamic-textarea.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-textarea.vue?vue&type=style&index=0&id=5668ccfd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5668ccfd",
  null
  
)

export default component.exports